<template>
	<v-layout row wrap v-if="(wasModified() || !otherCost) || !old">
		<v-flex d-flex xs1>
			<v-card :color=" color() + ' lighten-1'">
				<v-card-text class="px-2"><strong>{{cost.serialNumber}} {{status()}}</strong>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex d-flex xs2>
			<v-card :color="(namesDifferent() ? color() : 'grey') + ' lighten-1'">
				<v-card-text class="px-2"><strong>{{cost.name}}</strong>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex d-flex xs3>
			<v-card :color="(namesDifferent() ? color() : 'grey') + ' lighten-1'">
			</v-card>
		</v-flex>
		<v-flex d-flex xs1>
			<v-card :color="(totalPriceDifferent() ? color() : 'grey') + ' lighten-1'">
				<v-card-text class="px-1 text-center">{{formatMoney(cost.totalPrice)}}
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex d-flex xs1>
			<v-card :color="(fromDotationDifferent() ? color() : 'grey') + ' lighten-2'">
				<v-card-text class="px-1 text-center">{{formatMoney(cost.fromDotation)}}</v-card-text>
			</v-card>
		</v-flex>
		<v-flex d-flex xs2>
			<v-card :color="(fromOtherDifferent() ? color() : 'grey') + ' lighten-2'">
				<v-card-text class="px-1 text-center">{{formatMoney(cost.fromOther)}}</v-card-text>
			</v-card>
		</v-flex>
		<v-flex d-flex xs1>
			<v-card :color="(fromOwnHumanDifferent() ? color() : 'grey') + ' lighten-2'">
				<v-card-text class="px-1 text-center">{{formatMoney(cost.fromOwnHuman)}}</v-card-text>
			</v-card>
		</v-flex>
		<v-flex d-flex xs1>
			<v-card>
				<v-card :color="(fromOwnFinancialDifferent() ? color() : 'grey') + ' lighten-2'">
					<v-card-text class="px-1 text-center">{{formatMoney(cost.fromOwnFinancial)}}</v-card-text>
				</v-card>
			</v-card>
		</v-flex>
	</v-layout>
</template>
<script>
	import {Numbers} from "../../../../../utils/Numbers";

	export default {
		name: 'compare-costs-calculated-single-action',
		props: {
			old: Boolean,
			cost: {},
			otherCost: {},
		},
		mixins: [Numbers],
		computed: {},

		methods: {

			changedStyle () {
				return "darken-4";
			},

			propertiesDifferent (getter) {
				if (!this.otherCost) {
					return true;
				}
				return getter(this.otherCost) !== getter(this.cost);
			},

			status () {
				if (!this.otherCost) {
					return this.old ? '(Usunięte)' : '(Nowe)';
				}
				return this.wasModified() ? (this.old ? "(Było)" : "(Jest)") : '';
			},

			wasModified () {
				if (!this.otherCost) {
					return false;
				}
				return this.fromDotationDifferent() ||
					this.fromOtherDifferent() ||
					this.fromOwnHumanDifferent() ||
					this.fromOwnFinancialDifferent() ||
					this.namesDifferent();
			},

			totalPriceDifferent () {
				return this.propertiesDifferent(x => x.totalPrice);
			},

			fromOwnHumanDifferent () {
				return this.propertiesDifferent(x => x.fromOwnHuman);
			},

			fromOtherDifferent () {
				return this.propertiesDifferent(x => x.fromOther);
			},

			fromOwnFinancialDifferent () {
				return this.propertiesDifferent(x => x.fromOwnFinancial);
			},

			fromDotationDifferent () {
				return this.propertiesDifferent(x => x.fromDotation);
			},

			namesDifferent () {
				return this.propertiesDifferent(x => x.name);
			},

			color () {
				if (!this.otherCost) {
					return this.old ? 'red' : 'green';
				}
				return this.wasModified() ? "blue" : "grey";
			}

		}
	};
</script>
<style>
	.finance-table .v-card__text.text-center {
		text-align: center;
		font-size: 11px;
	}

	.finance-table .v-card__text,
	.finance-table .v-card {
		height: 100%;
	}

	.finance-table .v-card__text strong {
		font-size: 12px;
	}

	.finance-table strong {
		font-size: 12px;
	}

	.finance-table .v-card__text {
		padding-top: 7px;
		padding-bottom: 7px;
	}
</style>